import React from 'react'

import { useFormContext } from 'react-hook-form'

import { toISO8601 } from '@fortem-monorepo/js-utilities'
import { DatePicker, FormError } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'
import { Trades } from '@fortem-monorepo/web-sdk'

export interface TradeInstructionDateFormFieldProps {}

const _TradeInstructionDateFormField: React.FC<TradeInstructionDateFormFieldProps> = ({}) => {
  const { control } = useFormContext<Trades.BookTradeBody>()

  return (
    <FormField
      name="instruction_date"
      control={control}
      render={({ field }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2">
              <FormLabel>Trade Instruction Date</FormLabel>
              <FormError />
            </div>
            <DatePicker
              selected={field.value ? new Date(field.value) : undefined}
              onSelect={(date) => {
                field.onChange(date ? toISO8601(date) : '')
              }}
            />
          </FormItem>
        )
      }}
    />
  )
}

export const TradeInstructionDateFormField = React.memo(_TradeInstructionDateFormField)
